import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CopyIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M6.667 6A.667.667 0 0 0 6 6.667v6.666c0 .368.298.667.667.667h6.666a.667.667 0 0 0 .667-.667V6.667A.667.667 0 0 0 13.333 6H6.667Zm-2 .667a2 2 0 0 1 2-2h6.666a2 2 0 0 1 2 2v6.666a2 2 0 0 1-2 2H6.667a2 2 0 0 1-2-2V6.667Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M2.667 2A.67.67 0 0 0 2 2.667v6.666a.67.67 0 0 0 .667.667.667.667 0 0 1 0 1.333c-1.102 0-2-.898-2-2V2.667c0-1.102.898-2 2-2h6.666c1.102 0 2 .898 2 2a.667.667 0 1 1-1.333 0A.67.67 0 0 0 9.333 2H2.667Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CopyIcon;
